<script lang="ts">
    import { Col, Form, FormGroup, Input, Label, Row } from "sveltestrap";
    import { Looksgood, Title, Type, } from "../../../../utils/Constant/Constant";
    import {blogPostRadio} from "../../../../Data/Miscellaneous/Blog"
    import SelectDropdown from "./SelectDropdown.svelte";
</script>
<Form class="needs-validation" novalidate>
  <Row>
    <Col sm="12">
      <FormGroup>
        <Label for="validationCustom01">{Title}</Label>
        <Input
          id="validationCustom01"
          type="text"
          placeholder="Post Title"
          required />
        <div class="valid-feedback">{Looksgood}</div>
      </FormGroup>
      <FormGroup>
        <Label>{Type}</Label>
        <div class="m-checkbox-inline">
          {#each blogPostRadio as blogItem}
            <Label for="edo-ani{blogItem.id}">
              <Input
                class="radio_animated"
                id="edo-ani{blogItem.id}"
                type="radio"
                name="rdo-ani"
                checked />
              {blogItem.name}
            </Label>
          {/each}
        </div>
      </FormGroup>
      <SelectDropdown />
    </Col>
  </Row>
</Form>